import { ProjectDomainSelectModelSchema } from '../project.models.ts'
import { NonEmptyStringSchema } from '../property.models.ts'
import { ActivityLinkTargets } from './activity-data.models.ts'
import { ActivityTypeAndDataSchema } from './utilities.ts'

export const ProjectClosedActivityDetailsSchema = ActivityTypeAndDataSchema(
  'project_closed',
  ProjectDomainSelectModelSchema.pick({ projectId: true }).extend({
    reason: NonEmptyStringSchema(),
    ...ActivityLinkTargets('project'),
  })
)
